import React from "react";
import { observer } from "mobx-react";
import { PatientMissingDocsPreviewTemplate } from "themes/application/patient-missing-docs/pages";
import { PatientMissingDocsPreviewViewStore } from "application/patient-missing-docs/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new PatientMissingDocsPreviewViewStore(rootStore), "patientMissingDocsPreviewViewStore")
@observer
class PatientMissingDocsPreview extends React.Component {
	render() {
		return <PatientMissingDocsPreviewTemplate {...this.props} />;
	}
}

export default PatientMissingDocsPreview;